import {
  ORDERS_LINK,
  ORDERS_REVAMP_LINK,
} from 'components/UserAccountView/constants';
import { AB_CONVENIENCE_FEE } from 'constants/experiments';
import {
  AB_EMAIL_VERIFICATION_REVAMP,
  AB_ORDERS_REVAMP,
} from 'constants/product';
import { getEligibleForVariant } from 'helpers/experimentV2';
import { useSelector } from 'react-redux';
import { State } from 'store/types';

export const useOrdersUrl = () => {
  const ordersRedirectionExpEnabled = useSelector((state: State) =>
    getEligibleForVariant(state, AB_ORDERS_REVAMP, 'A')
  );
  const ordersRevampUrl = useSelector(
    (state: State) =>
      state.remoteConfig.configs?.ordersRevampUrl ||
      `${ORDERS_REVAMP_LINK}?src=web`
  );

  if (ordersRedirectionExpEnabled) {
    return ordersRevampUrl;
  }
  return `${ORDERS_LINK}?ptype=myOrder`;
};

export const useEmailVerificationRevamp = () => {
  const emailVerificationExpEnabled =
    useSelector((state: State) =>
      getEligibleForVariant(state, AB_EMAIL_VERIFICATION_REVAMP, 'A')
    ) || false;

  return emailVerificationExpEnabled;
};

export const useIsConvenienceFeeEnabled = () => {
  const convenienceFeeEnabled =
    useSelector((state: State) =>
      getEligibleForVariant(state, AB_CONVENIENCE_FEE, 'A')
    ) || false;

  return convenienceFeeEnabled;
};
